
import ParticipantGroupRegistrationRequest from "@/models/api/participant-group/ParticipantGroupRegisterRequest";
import Person from "@/models/api/person/Person";
import PersonRegistrationRequest from "@/models/api/person/PersonRegistrationRequest";
import VuetifyFormMethods from "@/models/vuetify-form-methods";
import { ParticipantService } from "@/services/ParticipantService";
import { PersonService } from '@/services/PersonService';
import { SnackbarService } from "@/services/SnackbarService";
import Vue from 'vue'
import { SettingService } from '../../services/SettingService';
import { ApplicationSetting, AssociationRoleEnum } from '../../models/Enums';
import ApplicationSettingDto from '../../models/api/ApplicationSetting';
import adaptSSN from '../../helpers/functions/AdaptSSN';
import adaptZipCode from '../../helpers/functions/AdaptZipCode';
import { validateSSNDate, validateDateOfBirth, validateSSN } from '../../helpers/functions/ValidateSSN';
import validateSSNSetting from '../../helpers/functions/ValidateSSNSetting';
import { ValidationHelper } from '../../helpers/ValidationHelper';
import AddPersonToGroupDialog from './AddPersonToGroupDialog.vue';



export default Vue.extend({
    components: {
        AddPersonToGroupDialog
    },
    props: {
        showDialog: Boolean,
        isOccasionParticipant: {
            type: Boolean,
            default: false
        },
        selectedOccasionGroupId: Number,

        //To show addtogroupdialog when arriving from occasion-page
        fromOccasion: Boolean,
    },   
    created() {
        this.showMoreFields = false;

        this.addParticipantDialogOpen = this.showDialog;

        SettingService.GetSettingsByKeyNames("IsSSNMandatory,FormatOfDateOfBirth")
            .then(response => {
                const settings = response.data as ApplicationSettingDto[];
                this.isSSNMandatory = JSON.parse(settings[this.getApplicationSetting(settings, ApplicationSetting.IsSSNMandatory)].value.toString().toLowerCase());
                this.formatDateOfBirth = settings[this.getApplicationSetting(settings, ApplicationSetting.FormatOfDateOfBirth)].value.toString();
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.$store.commit('removeOverlay');
            });

    },
    data() {
        return {
            addParticipantDialogOpen: false,
            
            selectedParticipant: {} as Person,
            
            participantSearchTerm: "",
            participantSearchTermTimeStamp: new Date(),

            searchedParticipants: new Array<Person>(),
            isParticipantSearchLoading: false,
            
            personRequest: new PersonRegistrationRequest("", "", "", "", "", "", "", "", null, null, [], false, false),
            participantRequest: new ParticipantGroupRegistrationRequest(0, 0, 0, false, false, false, false),
            participantRequestValid: false,
            addPersonToGroupDialogOpen: false,


            showMoreFields: false,
            genders: [{ text: this.$vuetify.lang.t('$vuetify.female'), value: 1 }, { text: this.$vuetify.lang.t('$vuetify.male'), value: 2 }],

            isSSNMandatory: false,
            formatDateOfBirth: "",
            rules: {
                required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required'),
                ssnFormat: (value: any) => !value || /^\d{4}\d{2}\d{2}-\d{4}$/.test(value) || this.$vuetify.lang.t('$vuetify.formatSSN'),
                validateSSNDate: (value: any) => validateSSNDate(value) || this.$vuetify.lang.t('$vuetify.person.invalidDate'),
            },
            phoneRules: [
                (v: any) => /^((\+\d{1,3}\s*[0-9]{1,3})|(0[0-9]{1,3}))-*\s*(\d{3,4})\s*(\d{2,3})\s*(\d{1,3})*$/.test(v) || v == null || v == "" || this.$vuetify.lang.t('$vuetify.person.invalidPhoneNumber'),
            ],
            emailRules: [
                (value: any) => !value
                    || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
                    || this.$vuetify.lang.t('$vuetify.invalidEmail'),
            ],
            zipCodeRules: [
                (value: any) => !value || /^\d{3}\s*\d{2}$/.test(value) || this.$vuetify.lang.t('$vuetify.invalidZipCode'),
            ],
            addPersonToGroup: false,
            //persons: new Array<Person>(),
        }
    },
    watch: {
        showDialog: {
            handler(newValue) {
                this.addParticipantDialogOpen = this.showDialog;

                if (this.showDialog) {
                    this.resetData();
                }
            }
        },
        participantSearchTerm: {
                handler(value: string) {
                    //console.log(value);

                    if(value != null && value.length > 0) {
                        
                        this.isParticipantSearchLoading = true;

                        this.participantSearchTermTimeStamp = new Date();

                        const timeStapm = this.participantSearchTermTimeStamp;

                        ParticipantService.searchParticipants(value).then(response => {
                            console.log(response.data);

                            if (timeStapm == this.participantSearchTermTimeStamp) {
                                this.searchedParticipants = response.data.map(x => ({ ...x, nameBlob: x.firstName + " " + x.lastName }));
                            }
                        }).catch(error => {
                            console.log(error);
                            
                            SnackbarService.addErrorMessage(error);
                        }).finally(() => {
                            this.isParticipantSearchLoading = false;
                        });
                    } else {
                        this.searchedParticipants = [];
                    }
                },
            },
    },
    methods: {
        getValidationRules(): any[] {
            setTimeout(() => (this.$refs.personDialog as VuetifyFormMethods)?.validate());
            if (this.isSSNMandatory && !this.personRequest.hasNoSwedishSsn) {
                return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.rules.ssnFormat];
            }
            return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.validDateOfBirth];
        },
        validDateOfBirth(value: string): string | boolean {
            return validateDateOfBirth(value, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.person.invalidDate');
        },
        /* Not to be used before getPersons() is fixed to not fetch all persons full info and called on created!!!
        async getPersons() {
            this.persons = (await PersonService.GetPersons()).data;
        },
        uniqueSocialSecurityNumber(value: string): string | boolean {
            // Filter except from the item being edited.

            if (
                value &&
                this.persons
                    .filter((x) => x.id != this.personRequest.id)
                    .findIndex(
                        (f) =>
                            f.socialSecurityNumber.trim().toLocaleLowerCase() ==
                            value.trim().toLocaleLowerCase()
                    ) > -1
            ) {
                return false;
                //return this.$vuetify.lang.t('$vuetify.person.SSNAlreadyExists') + " " + value;
            }

            return true;
        },*/
        checkValidSSN(value: string): string | boolean {
            return validateSSN(value) || this.$vuetify.lang.t('$vuetify.invalidSSN');
        },
        validateSSNSettings(v: any): boolean | string {
            return validateSSNSetting(v, this.isSSNMandatory && !this.personRequest.hasNoSwedishSsn, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.invalidSSN');
        },
        fixSSN() {
            this.personRequest.socialSecurityNumber = adaptSSN(this.personRequest.socialSecurityNumber);
        },
        fixZipCode() {
            this.personRequest.zipCode = adaptZipCode(this.personRequest.zipCode);
        },

        getApplicationSetting(settings: ApplicationSettingDto[], app: ApplicationSetting) {
            return settings.findIndex((val: any) => val.keyName == app);
        },
        toggleShowMoreFields() {
            this.showMoreFields = !this.showMoreFields;
        },
        validateParticipant() {
            if (this.selectedParticipant?.firstName?.length > 0) {
                // Person already registered

                this.participantRequest.personId = this.selectedParticipant.id;
                this.participantRequest.person = this.selectedParticipant;
                this.participantRequest.isDisabled = this.selectedParticipant.isDisabled;

                if (this.selectedParticipant.associationRole == AssociationRoleEnum.AssociationAdmin) {
                    this.participantRequest.isAssociationAdmin = true;
                }

                // We should never automatically add participant as admin
                this.participantRequest.isAdmin = false;

                if (this.participantRequest.isDisabled == null) {
                    // Make sure we have a valid value
                    this.participantRequest.isDisabled = false;
                }

                if (this.participantRequest.isLeader == null) {
                    // Make sure we have a valid value
                    this.participantRequest.isLeader = false;
                }

                // this.registrationRequest.participants.push(this.participantRequest);

                // this.addParticipantDialogOpen = false;

                // Reset participant request
                this.addPersonToGroupDialogOpen = true;
            }
            else {
                if (!(this.$refs.personDialog as VuetifyFormMethods).validate()) {
                    return;
                }
                this.addPersonToGroupDialogOpen = true;
            }

        },
        addParticipant(addPersonToGroup: boolean) {
            this.addPersonToGroup = addPersonToGroup;
                if (this.selectedParticipant?.firstName?.length > 0) {
                    // Person already registered

                    this.participantRequest.personId = this.selectedParticipant.id;
                    this.participantRequest.person = this.selectedParticipant;
                    this.participantRequest.isDisabled = this.selectedParticipant.isDisabled;

                    if (this.selectedParticipant.associationRole == AssociationRoleEnum.AssociationAdmin) {
                        this.participantRequest.isAssociationAdmin = true;
                    }

                    // We should never automatically add participant as admin
                    this.participantRequest.isAdmin = false;

                    if (this.participantRequest.isDisabled == null) {
                        // Make sure we have a valid value
                        this.participantRequest.isDisabled = false;
                    }

                    if (this.participantRequest.isLeader == null) {
                        // Make sure we have a valid value
                        this.participantRequest.isLeader = false;
                    }

                    // this.registrationRequest.participants.push(this.participantRequest);

                    // this.addParticipantDialogOpen = false;

                    // Reset participant request
                    this.addPersonToGroupDialogOpen = false;

                    this.emitParticipant();
                } else {
                    // Add new person

                    if (!(this.$refs.personDialog as VuetifyFormMethods).validate()) {
                        return;
                    }
                    this.addPersonToGroupDialogOpen = false;

                    PersonService.RegisterPerson(this.personRequest, "", true).then(response => {
                        const person = response.data as Person; 

                        console.log("Save person: ", person);
                        this.participantRequest.personId = person.id;
                        this.participantRequest.person = person;
                        this.participantRequest.isDisabled = person.isDisabled;

                        // this.registrationRequest.participants.push(this.participantRequest);
                        
                        SnackbarService.addSuccessMessage("Personen har registrerats");
                        // this.addParticipantDialogOpen = false;
                        this.emitParticipant();
                }).catch(error => {
                    console.log(error);
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                });
            }
        },

        resetData(): void {
            this.selectedParticipant = {} as Person;
            this.personRequest = new PersonRegistrationRequest("", "", "", "", "", "", "","", null, null, [], false, false);
            this.participantRequest = new ParticipantGroupRegistrationRequest(0, 0, 0, false, false, false, false);

            this.$nextTick(() => { console.log("triggered!"); console.log(this.$refs.personDialog as VuetifyFormMethods); (this.$refs.personDialog as VuetifyFormMethods)?.resetValidation(); });

        },
        emitParticipant() {
            //Send participant and if said person should be added to the group aswell
            this.$emit("participant-added", this.participantRequest, this.addPersonToGroup);
        },
        dialogClosed() {
            (this.$refs.personDialog as VuetifyFormMethods).reset();
            // this.resetData();
            this.$emit("dialog-closed");
        },
    }
})
